import React from "react";
import { Icon, IconProps } from "../Icon"; // Import the generic Icon component

export const NextArrow = (props: IconProps) => {
  return (
    <Icon
      classes={`${props.classes || ""} ons-icon--m ons-u-ml-xs`}
      height="24px"
      width="24px"
      viewBox="0 0 17 13"
      focusable={false}
    >
      <path d="m10 .2-.9.9c-.1.1-.1.4 0 .5l4 4H.6c-.2 0-.4.2-.4.4v1.2c0 .2.2.4.4.4h12.5l-3.9 3.7c-.2.2-.2.4 0 .6l.8.9c.2.2.4.2.6 0L16.8 7c.2-.2.2-.4 0-.6L10.7.3c-.3-.2-.5-.2-.7-.1z" />
    </Icon>
  );
};
